import $api from "../../axios"
import {AppDispatch} from "../index"
import {notificationSlice} from "../slices/notificationSlice"

export const fetchNotifications = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(notificationSlice.actions.fetching())
    const response = await $api.get("request/notification/index")
    dispatch(notificationSlice.actions.fetchSuccess(response.data))
    return response
  } catch (e: any) {
    console.log(e)
  }
}

export const notificationRead = (id: number) => async (dispatch: AppDispatch) => {
  try {
    await $api.put("request/notification/read", {id})
    return true
  } catch (e: any) {
    console.log(e)
  }
}